<template>
    <a class="page__header__back-btn">
        <icon icon="chevron-left" />
    </a>
</template>

<script>    
    export default {}
</script>

<style scoped lang="scss">
    @import '../../../scss/layouts/header.scss';
</style>